// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eO","menuControls_styleDefault":"c-a_eP","menuControls_styleRed":"c-a_eQ"};